// gsap is loaded on demand so it stays out of the shared vendor bundle —
// the welcome page is the only place that uses it.
import(/* webpackChunkName: "gsap" */ "gsap").then(({ gsap }) => {
    //  TODO gsap.fromTo() használata timeline helyett
    const tl = gsap.timeline();

    tl.set("#t-simple", {
        translateY: "50px",
        opacity: 0,
    });

    const animate = () => {
        // First texts
        tl.to("#t-simple", {
            translateY: 0,
            duration: 1,
            opacity: "100%",
        });
    };

    if (document.readyState === "complete") {
        animate();
    } else {
        window.addEventListener("load", animate);
    }
});
